import { css } from 'styled-components';
export const basicStyle = css(["overflow-x:auto;overflow-y:hidden;-webkit-overflow-scrolling:touch;&::-webkit-scrollbar{height:0;}"]);
export const contentStyle = css(["display:flex;flex-wrap:nowrap;"]);
//# sourceMappingURL=HScroll.style.js.map